export default __webpack_public_path__ + "3de218df3e3767d169de7ebc6b449c7d.png";